import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Protocol } from 'src/app/interfaces/protocol.interfaces';

@Component({
    selector: 'protocol-form',
    templateUrl: 'protocol-form.component.html',
    styleUrls: ['./protocol-form.component.scss'],
    standalone: false
})
export class ProtocolFormComponent implements OnInit {
    @Input() public protocol: Protocol = new Protocol([]);
    @Output('onSubmit') public onSubmitEmitter = new EventEmitter();
    public constructor() {}

    public ngOnInit() {}

    public onSubmit(e: Event) {
        // console.log(e);
        this.onSubmitEmitter.emit(e);
    }
}
